module["exports"] = [
  "საქართველო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/default_country.js
// module id = 2356
// module chunks = 2